/*
  EXA — Temporizador de reserva do carrinho + faixas de desconto por quantidade
  Substitui a antiga barra de envío gratis por limiar (agora é política fixa,
  sem cálculo — ver markup em snippets/cart-drawer.liquid).
*/
(function () {
  var TIMER_KEY = 'exaCartTimerExpires10m';
  var TIMER_DURATION = 10 * 60 * 1000; // 10 minutos

  var TIERS = [
    { min: 4, pct: 25 },
    { min: 3, pct: 20 },
    { min: 2, pct: 15 }
  ];

  function formatTime(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  var tickHandle = null;

  function tickTimer() {
    if (tickHandle) clearTimeout(tickHandle);
    var el = document.querySelector('[data-exa-timer-value]');
    if (!el) return;
    var expires = parseInt(sessionStorage.getItem(TIMER_KEY), 10);
    if (!expires) return;
    var remaining = expires - Date.now();
    if (remaining <= 0) {
      sessionStorage.removeItem(TIMER_KEY);
      el.textContent = '0:00';
      return;
    }
    el.textContent = formatTime(remaining);
    tickHandle = setTimeout(tickTimer, 500);
  }

  function ensureTimerStarted(itemCount) {
    if (itemCount > 0 && !sessionStorage.getItem(TIMER_KEY)) {
      sessionStorage.setItem(TIMER_KEY, Date.now() + TIMER_DURATION);
    }
    if (itemCount === 0) {
      sessionStorage.removeItem(TIMER_KEY);
    }
  }

  function paintTiers(itemCount) {
    var items = document.querySelectorAll('[data-exa-tier-discount] .exa-tier-discount__item');
    for (var i = 0; i < items.length; i++) {
      var tierMin = parseInt(items[i].getAttribute('data-tier'), 10);
      items[i].classList.toggle('is-achieved', itemCount >= tierMin);
    }

    var message = document.querySelector('[data-exa-tier-message]');
    if (!message) return;

    var achieved = null;
    var next = null;
    for (var a = 0; a < TIERS.length; a++) {
      if (itemCount >= TIERS[a].min) { achieved = TIERS[a]; break; }
    }
    for (var b = TIERS.length - 1; b >= 0; b--) {
      if (itemCount < TIERS[b].min) { next = TIERS[b]; break; }
    }

    if (next) {
      var missing = next.min - itemCount;
      message.textContent = 'Añade ' + missing + ' artículo' + (missing > 1 ? 's' : '') + ' más y consigue ' + next.pct + '% EXTRA';
    } else if (achieved) {
      message.textContent = '✓ Tienes ' + achieved.pct + '% de descuento extra aplicado';
    } else {
      message.textContent = '';
    }
  }

  function refresh() {
    var hasTiers = document.querySelector('[data-exa-tier-discount]');
    var hasTimer = document.querySelector('[data-exa-cart-timer]') || sessionStorage.getItem(TIMER_KEY);
    if (!hasTiers && !hasTimer) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ensureTimerStarted(cart.item_count);
        paintTiers(cart.item_count);
        tickTimer();
      })
      .catch(function () {});
  }

  function init() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refresh, 80); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();